import { Theme } from '@mui/material/styles';

export default function Popover(theme: Theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.background.default,
          border: `.5px solid ${theme.palette.divider}`,
          marginTop: theme.spacing(1),
          boxShadow: theme.customShadows.dropdown,
          borderRadius: 0,
          '&.MuiPaper-rounded': {
            borderRadius: theme.spacing(1),
          },
        },
      },
    },
  };
}
